export interface PaginationParams {
    pageNumber?: number;
    pageSize?: number;
    sortBy?: string;
    sortDirection?: 'ASC' | 'DESC';
    search?: string;
    statusFilter?: string;
}

export interface PaginationMeta {
    pageNumber: number;
    pageSize: number;
    totalPageItems: number;
    totalRecords: number;
    totalPages: number;
}

export interface PaginatedState<T> {
    items: T[];
    pagination: PaginationMeta;
    sort: { sortBy: string; sortDirection: 'ASC' | 'DESC' };
    loading: boolean;
    error: string | null;
    stale: boolean;
}

export const DEFAULT_PAGE_SIZE = 25;

export const DEFAULT_PAGINATION_META: PaginationMeta = {
    pageNumber: 0,
    pageSize: DEFAULT_PAGE_SIZE,
    totalPageItems: 0,
    totalRecords: 0,
    totalPages: 0,
};

export const DEFAULT_PAGINATION_PARAMS: PaginationParams = {
    pageNumber: 0,
    pageSize: DEFAULT_PAGE_SIZE,
    sortBy: 'id',
    sortDirection: 'DESC',
};

export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export function loadPaginationPrefs(sliceName: string): { pageSize: number; sortBy: string; sortDirection: 'ASC' | 'DESC' } {
    try {
        const stored = localStorage.getItem(`pagination-prefs-${sliceName}`);
        if (stored) {
            return JSON.parse(stored);
        }
    } catch { /* ignore */ }
    return { pageSize: DEFAULT_PAGE_SIZE, sortBy: 'id', sortDirection: 'DESC' };
}

export function savePaginationPrefs(sliceName: string, prefs: { pageSize: number; sortBy: string; sortDirection: 'ASC' | 'DESC' }) {
    localStorage.setItem(`pagination-prefs-${sliceName}`, JSON.stringify(prefs));
}
